import {
  Center,
  Container,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Text,
  useDisclosure,
  Input,
  Select,
  Card,
  Button,
  Portal,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Link,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import BreadCrumName from "../../components/BreadCrumName";
import { useNavigate } from "react-router-dom";
import { FaFileDownload } from "react-icons/fa";
import { FiEye, FiTrash2 } from "react-icons/fi";
import { BiEditAlt } from "react-icons/bi";
import Loader from "../../components/Loader";
import store from "../../redux/Store";
import { getDocument_list } from "../../redux/slice/DocumentSlice";
import { useSelector } from "react-redux";
import ImageModal from "../../components/ImageModal";
import moment from "moment";
import CustomPopup from "../../components/CustomPopup";
import { decryptData, downloadImage } from "../../utils/utils";
import { addUserDocument } from "../../utils/apis";
import { IoMdMore } from "react-icons/io";
import { getUserData } from "../../redux/slice/userSlice";

const ArchivedDocument = () => {
  const navigate = useNavigate();
  const loggedInUser = localStorage.getItem("user");
  const user = JSON.parse(loggedInUser);
  const ID = user?.userid;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { document_list, d_loading } = useSelector((state) => state.document);
  const { user_data } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState("");
  const [id, setId] = useState("");
  const {
    isOpen: isPOpen,
    onOpen: onPOpen,
    onClose: onPClose,
  } = useDisclosure();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [search, setSearch] = useState("");
  const [initialValue, setInitialValue] = useState(1);
  const [totalCount, setTotalCount] = useState(document_list?.length);
  const [url, setUrl] = useState("");

  const filterCount = () => {
    const count = data.filter((v) => {
      const formats = ["DD/MM/YYYY", "YYYY/MM/DD", "YYYY-MM-DD", "DD-MM-YYYY"];
      let matchFound = false;

      formats.forEach((format) => {
        const formattedSearch = moment(search, format, true);
        const expiryDate = moment(v.expiry_date, "YYYY-MM-DD", true);
        if (
          formattedSearch.isValid() &&
          expiryDate.isValid() &&
          formattedSearch.isSame(expiryDate, "day")
        ) {
          matchFound = true;
        }
      });
      return (
        v?.Name.toLowerCase().includes(search.toLowerCase()) ||
        v?.doc_type.toLowerCase().includes(search.toLowerCase()) ||
        moment(v?.expiry_date)?.format("DD/MM/YYYY").includes(search) ||
        moment(v?.expiry_date)?.format("YYYY/MM/DD").includes(search) ||
        moment(v?.expiry_date)?.format("DD-MM-YYYY").includes(search) ||
        moment(v?.expiry_date)?.format("DD/MM/YY").includes(search) ||
        moment(v?.expiry_date)?.format("MM/DD/YY").includes(search) ||
        moment(v?.expiry_date)?.format("YY/MM/DD").includes(search) ||
        moment(v?.expiry_date)?.format("DD MMM YYYY").includes(search) ||
        moment(v?.expiry_date)?.format("DD MMMM YYYY").includes(search) ||
        moment(v?.expiry_date)?.format("YYYY MMM DD").includes(search) ||
        matchFound
      );
    });

    setTotalCount(count?.length);
  };

  const todayDate = new Date();
  todayDate.setDate(todayDate.getDate() - 1);
  const data = document_list.filter((item) => {
    return (
      moment(item.expiry_date).format("YYYY-MM-DD  HH:mm:ss") <
      moment(todayDate).format("YYYY-MM-DD  HH:mm:ss")
    );
  });

  const delete_doc = () => {
    onPClose();
    const body = new FormData();
    body.append("action", "delete");
    body.append("id", id);
    addUserDocument(body, setLoading).then(
      (v) => v.success && store.dispatch(getDocument_list(user.userid))
    );
  };

  useEffect(() => {
    localStorage.getItem("user");
    store.dispatch(getDocument_list(user.userid));
    filterCount();
  }, []);

  useEffect(() => {
    filterCount();
  }, [search]);

  function daysRemaining(date) {
    var eventdate = moment(date);
    var todaysdate = moment();
    return eventdate.diff(todaysdate, "days");
  }

  return (
    <Container maxW={"container.xl"} w={"full"} mt={5}>
      <BreadCrumName
        current={"Archived Documents"}
        titlelist={[{ name: "Home", to: "/" }]}
      />
      <Flex align={"center"} justify={"space-between"} mb={5} mt={4}>
        <Heading
          fontSize={["md", "lg", "xl", "2xl"]}
          fontWeight={"medium"}
          color={"#fff"}
        >
          Archived Documents
        </Heading>
      </Flex>
      {data?.length == 0 || (
        <Flex
          gap={2}
          flexDirection={["column", "column", "row"]}
          justifyContent={"space-between"}
          mb={3}
        >
          <Flex
            gap={2}
            alignItems={"center"}
            alignSelf={"start"}
            color={"#fff"}
          >
            <Text>Show</Text>
            <Select
              color={"#000"}
              W={"44"}
              backgroundColor={"#fff"}
              size={"sm"}
              borderRadius={5}
              value={limit}
              onChange={(e) => {
                setLimit(e.target.value);
                setPage(1);
              }}
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
            <Text>entries</Text>
          </Flex>
          <Flex gap={2} alignItems={"center"} color={"#fff"}>
            <Text>Search:</Text>
            <Input
              placeholder="Search document"
              w={"xs"}
              size="md"
              color={"#000"}
              backgroundColor={"#fff"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Flex>
        </Flex>
      )}
      {d_loading && data?.length !== 0 ? (
        <Loader />
      ) : data?.length == 0 ? (
        <Center flexDirection={"column"}>
          <Image src={"no-data1.png"} w={["xs", "sm"]} objectFit={"contain"} />
        </Center>
      ) : (
        <>
          <SimpleGrid columns={[1, 2, 3, 4]} spacing={5} mt={3}>
            {data
              .filter((v) => {
                const formats = [
                  "DD/MM/YYYY",
                  "YYYY/MM/DD",
                  "YYYY-MM-DD",
                  "DD-MM-YYYY",
                ];
                let matchFound = false;

                formats.forEach((format) => {
                  const formattedSearch = moment(search, format, true);
                  const expiryDate = moment(v?.expiry_date, "YYYY-MM-DD", true);
                  if (
                    formattedSearch.isValid() &&
                    expiryDate.isValid() &&
                    formattedSearch.isSame(expiryDate, "day")
                  ) {
                    matchFound = true;
                  }
                });
                return (
                  v?.Name.toLowerCase().includes(search.toLowerCase()) ||
                  v?.doc_type.toLowerCase().includes(search.toLowerCase()) ||
                  moment(v?.expiry_date)
                    ?.format("DD/MM/YYYY")
                    .includes(search) ||
                  moment(v?.expiry_date)
                    ?.format("YYYY/MM/DD")
                    .includes(search) ||
                  moment(v?.expiry_date)
                    ?.format("DD-MM-YYYY")
                    .includes(search) ||
                  moment(v?.expiry_date)?.format("DD/MM/YY").includes(search) ||
                  moment(v?.expiry_date)?.format("MM/DD/YY").includes(search) ||
                  moment(v?.expiry_date)?.format("YY/MM/DD").includes(search) ||
                  moment(v?.expiry_date)
                    ?.format("DD MMM YYYY")
                    .includes(search) ||
                  moment(v?.expiry_date)
                    ?.format("DD MMMM YYYY")
                    .includes(search) ||
                  moment(v?.expiry_date)
                    ?.format("YYYY MMM DD")
                    .includes(search) ||
                  matchFound
                );
              })
              .slice(initialValue - 1, limit * page)
              .map((v, i) => (
                <Card p={3} key={i}>
                  <Container
                    height={"100%"}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"space-between"}
                  >
                    <Flex flexDirection={"column"}>
                      <Flex align={"center"} justify={"space-between"}>
                        <Text
                          fontSize={["sm", "md", "xl", "lg"]}
                          fontWeight={"medium"}
                          textAlign={"center"}
                        >
                          {v.doc_type}
                        </Text>
                        <Popover placement="bottom-end">
                          <PopoverTrigger>
                            <Button
                              borderRadius={"full"}
                              bg={"transparent"}
                              px={0}
                              py={0}
                              m={0}
                              _hover={{ bg: "transparent" }}
                            >
                              <IoMdMore size={25} />
                            </Button>
                          </PopoverTrigger>
                          <Portal>
                            <PopoverContent w={"auto"} h={"auto"}>
                              <PopoverArrow />
                              <PopoverBody>
                                <CustomLink
                                  icon={<BiEditAlt size={18} color="blue" />}
                                  title={"Edit"}
                                  onClick={() =>
                                    navigate("/edit-document", { state: v })
                                  }
                                />
                                <CustomLink
                                  icon={<FiTrash2 size={18} color="#f00" />}
                                  title={"Delete"}
                                  onClick={() => {
                                    setId(v.id);
                                    onPOpen();
                                  }}
                                />
                                {v?.document?.split(".")?.pop()?.trim() ===
                                "pdf" ? (
                                  <Link href={v?.document} download isExternal>
                                    <CustomLink
                                      icon={
                                        <FaFileDownload
                                          size={18}
                                          color="#000"
                                        />
                                      }
                                      title={"Download"}
                                    />
                                  </Link>
                                ) : (
                                  <CustomLink
                                    onClick={() => {
                                      downloadImage(decryptData(v?.document));
                                    }}
                                    icon={
                                      <FaFileDownload size={18} color="#000" />
                                    }
                                    title={"Download"}
                                  />
                                )}
                              </PopoverBody>
                            </PopoverContent>
                          </Portal>
                        </Popover>
                      </Flex>
                      <Text
                        fontSize={["xs", "sm", "md"]}
                        fontWeight={"medium"}
                        mb={0}
                      >
                        Name: {v.Name}
                      </Text>
                      {Date.parse(v.expiry_date) ? (
                        <Flex gap={1} alignItems={"center"} mt={"5px"}>
                          <Text
                            fontSize={["xs", "sm", "md"]}
                            fontWeight={"medium"}
                            mb={0}
                          >
                            Expiry Date:
                          </Text>
                          <Text
                            fontSize={["xs", "sm", "md"]}
                            fontWeight={"medium"}
                            mb={0}
                            px={2}
                            borderRadius={3}
                            color={
                              daysRemaining(v.expiry_date) < 7
                                ? "#fff"
                                : daysRemaining(v.expiry_date) < 15
                                ? "#fff"
                                : daysRemaining(v.expiry_date) < 30
                                ? "#fff"
                                : "#000"
                            }
                            bg={
                              daysRemaining(v.expiry_date) < 7
                                ? "#f00"
                                : daysRemaining(v.expiry_date) < 15
                                ? "#FFCC00"
                                : daysRemaining(v.expiry_date) < 30
                                ? "#A9A9A9"
                                : "#fff"
                            }
                          >
                            {moment(v.expiry_date).format("DD/MM/YYYY")}
                          </Text>
                        </Flex>
                      ) : (
                        ""
                      )}
                    </Flex>
                    <Text
                      mt={2}
                      cursor={"pointer"}
                      alignSelf={"end"}
                      fontWeight={"semibold"}
                      color={"#e0a604"}
                      onClick={() => {
                        setIndex(i);
                        setUrl(decryptData(v?.document));
                        onOpen();
                      }}
                    >
                      View
                    </Text>
                  </Container>
                </Card>
              ))}
          </SimpleGrid>
          {data?.filter((v) => {
            const formats = [
              "DD/MM/YYYY",
              "YYYY/MM/DD",
              "YYYY-MM-DD",
              "DD-MM-YYYY",
            ];
            let matchFound = false;

            formats.forEach((format) => {
              const formattedSearch = moment(search, format, true);
              const expiryDate = moment(v?.expiry_date, "YYYY-MM-DD", true);

              if (
                formattedSearch.isValid() &&
                expiryDate.isValid() &&
                formattedSearch.isSame(expiryDate, "day")
              ) {
                matchFound = true;
              }
            });
            return (
              v?.Name.toLowerCase().includes(search.toLowerCase()) ||
              v?.doc_type.toLowerCase().includes(search.toLowerCase()) ||
              moment(v?.expiry_date)?.format("DD/MM/YYYY").includes(search) ||
              moment(v?.expiry_date)?.format("YYYY/MM/DD").includes(search) ||
              moment(v?.expiry_date)?.format("DD-MM-YYYY").includes(search) ||
              moment(v?.expiry_date)?.format("DD/MM/YY").includes(search) ||
              moment(v?.expiry_date)?.format("MM/DD/YY").includes(search) ||
              moment(v?.expiry_date)?.format("YY/MM/DD").includes(search) ||
              moment(v?.expiry_date)?.format("DD MMM YYYY").includes(search) ||
              moment(v?.expiry_date)?.format("DD MMMM YYYY").includes(search) ||
              moment(v?.expiry_date)?.format("YYYY MMM DD").includes(search) ||
              matchFound
            );
          })?.length == 0 && (
            <Text
              p={2}
              py={5}
              textAlign={"center"}
              fontSize={"lg"}
              fontWeight={"600"}
              color={"#fff"}
            >
              No Documents Found
            </Text>
          )}
        </>
      )}
      <ImageModal isOpen={isOpen} onClose={onClose} url={url} />
      <CustomPopup
        isOpen={isPOpen}
        onClick={() => delete_doc()}
        onClose={onPClose}
        b_name={"Delete"}
        title={"Delete"}
        mess={"Are you sure? You want to delete document"}
      />
      {totalCount == 0 || (
        <Flex
          gap={2}
          flexDirection={["column", "row"]}
          justifyContent={"space-between"}
          mt={3}
          color={"#fff"}
        >
          <Text>{`Showing ${initialValue} to ${
            limit * page >= totalCount ? data?.length : page * limit
          } of ${data?.length} entries`}</Text>
          <Flex gap={2} color={"#fff"}>
            <Text
              cursor={page < 2 ? "not-allowed" : "pointer"}
              color={page < 2 ? "#fff" : "#FFD700"}
              fontSize={"lg"}
              fontWeight={"500"}
              onClick={() => {
                page > 1 && setPage(page - 1);
                page > 1 &&
                  setInitialValue(Number(initialValue) - Number(limit));
              }}
            >
              Previous
            </Text>
            <Text fontSize={"lg"} fontWeight={"500"}>
              {page}
            </Text>
            <Text
              cursor={limit * page >= totalCount ? "not-allowed" : "pointer"}
              color={limit * page >= totalCount ? "#fff" : "#FFD700"}
              fontSize={"lg"}
              fontWeight={"500"}
              onClick={() => {
                limit * page >= totalCount || setPage(page + 1);
                limit * page >= totalCount ||
                  setInitialValue(Number(initialValue) + Number(limit));
              }}
            >
              Next
            </Text>
          </Flex>
        </Flex>
      )}
    </Container>
  );
};

const CustomLink = ({ icon, title, onClick }) => {
  return (
    <Flex gap={2} align={"center"} cursor={"pointer"} onClick={onClick} mt={2}>
      {icon}
      <Text fontSize={"sm"} fontWeight={"medium"}>
        {title}
      </Text>
    </Flex>
  );
};

export default ArchivedDocument;
